import { MethodType } from '../constants/MethodType'
const api = require('./api')

export const fetchRoleList = params => api.request(1, '/roles?includes=functions', MethodType.GET, params)

export const fetchRole = (id, params) => api.request(1, `/roles/${id}?includes=functions`, MethodType.GET, params)

export const addRole = params => api.request(1, '/roles', MethodType.POST, params)

export const modifyRole = (id, params) => api.request(1, `/roles/${id}`, MethodType.PUT, params)

export const deleteRole = (id, params) => api.request(1, `/roles/${id}`, MethodType.DELETE, params)

export const addUserRole = params => api.request(1, '/userRoleBulk', MethodType.POST, params)

export const modifyUserRole = params => api.request(1, '/userRoleModify', MethodType.PUT, params)

export const addRolePermission = params => api.request(1, '/rolePermissionBulkCreate', MethodType.POST, params)

export const modifyRolePermission = (params) => api.request(1, '/rolePermissionBulkModify', MethodType.PUT, params)
